import { useEffect, useMemo } from 'react'

import { AuthStatus, useAuthContext } from '@space-shell/common/contexts/auth'
import useLocalStorage from '@space-shell/common/hooks/useLocalStorage'
import { CookieUtils } from '@space-shell/common/utils/cookie'

import { useAuthStore } from '@space-shell/core/store'
import { v4 as uuidv4 } from 'uuid'

import { OPTIMIZELY_VISITOR_ID_STORAGE_KEY } from '../constants'

export const useVisitorId = () => {
  const { authStatus } = useAuthContext()
  const { ucode } = useAuthStore()

  // Visitor id to start optimizely, when user is not logged
  const [storedVisitorId, setStoredVisitorId] = useLocalStorage<string>(
    OPTIMIZELY_VISITOR_ID_STORAGE_KEY
  )

  const visitorId = useMemo(() => {
    if (authStatus === AuthStatus.AUTHENTICATED) {
      return ucode
    }

    const gaCookie = CookieUtils.getCookieByKey(document.cookie, '_ga')
    const isValidGaCookie = gaCookie && gaCookie !== 'undefined'

    return isValidGaCookie ? gaCookie : uuidv4()
  }, [authStatus, ucode])

  useEffect(() => setStoredVisitorId(visitorId), [setStoredVisitorId, visitorId])

  return storedVisitorId
}
